<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <p>Create Project Workflow Status</p>
    <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div style="height: 10px;">

</div>
<div mat-dialog-content>
  <mat-accordion>
    <mat-expansion-panel [expanded]="true">
      <form [formGroup]="PWorkflowStatus" autocomplete="off" class="eip=pt-20">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="displayText"
             formControlName="status" ValueField="dedId" WaterMarkText="Select Status" [dataSource]='stageList' 
             required [defaultValue]='dedId' setId="ddlstatus" (valueChange)='statusChage($event)'  [IsCascading]='true'> 
             </EIPAutoComplete>
             <mat-error  *ngIf="(PWorkflowStatus.get('status').dirty || PWorkflowStatus.get('status').touched) && PWorkflowStatus.get('status').hasError('required')" style="margin-top: -15px;">
                                Status is required  
              </mat-error> 
         </div>
        
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
             <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="Desc"
             formControlName="statusType" ValueField="status_Type" WaterMarkText="Select Status Type" [dataSource]='stageTypeList' 
             required  [defaultValue]='status_TypeId' setId="ddlstatusType" (valueChange)='statustypeChage($event)'   [IsCascading]='true'> 
              </EIPAutoComplete>
              <mat-error  *ngIf="(PWorkflowStatus.get('statusType').dirty ||PWorkflowStatus.get('statusType').touched) && PWorkflowStatus.get('statusType').hasError('required')" style="margin-top: -15px;">
                Status Type is required  
              </mat-error>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field style="width: 100%;">
              <mat-label>Status Order</mat-label>
              <input required type="number" matInput formControlName="statusOrder" >
            </mat-form-field>
            <mat-error  *ngIf="(PWorkflowStatus.get('statusOrder').dirty ||PWorkflowStatus.get('statusOrder').touched) && PWorkflowStatus.get('statusOrder').hasError('required')" style="margin-top: -15px;">
              Status Order is required  
            </mat-error>
          </div>
           <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field style="width: 100%;">
              <mat-label>Project Status Desc</mat-label>
              <input matInput formControlName="projectStatusDesc" >
            </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field style="width: 100%;">
              <mat-label>S-Curve Status Desc</mat-label>
              <input matInput formControlName="sCurveStatusDesc" >
            </mat-form-field>
          </div>
          
       
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field floatLabel="always" appearance="none">
              <mat-label>Status</mat-label>
              <mat-slide-toggle color="primary" formControlName="isActive">
              </mat-slide-toggle>
              <textarea matInput hidden></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
    <button (click)="save()" class="btn btn-primary"  type="submit" [disabled]="!PWorkflowStatus.valid"
      id="btnEDMSave">{{actionButtonText}}</button>
    <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel">Cancel</button>
  </div>
</div>

